export const rowNumberUtils = (page, row) =>{
    return ((page -1)*25) + (1 + row)
}

export const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}